import { ArtistsState, SearchActionResponse } from 'types'

export const initialState: ArtistsState = {}

export const reducer = (state: ArtistsState = initialState, action: SearchActionResponse): ArtistsState => {
  switch (action.type) {
    case 'FETCH_ARTISTS_DONE': {
      const {
        data: {
          queryString,
          response: { result, next, count },
        },
      } = action

      const query = String(queryString || 'default')
      const oldArtistIds = state[query]?.ids
      return {
        ...state,
        [query]: {
          count,
          lastPageLoaded: next - 1,
          ids: [...(oldArtistIds || []), ...result],
        },
      }
    }
    default:
      return state
  }
}

export default reducer
